module.exports = __webpack_public_path__ + "img/attention.e41db30a.svg";